import React, { useState, useEffect } from 'react';

import { SingleInput, SingleText } from '../../Res/BaseInput';
import { RespCustomerContract_Contact } from '../../../../item/ItemCustomerContract';
import { Space } from '../../Res/BaseButton';

export function ItemPersonnelContact({ item, action, isEdit = true }) {
  const [personnelContact, setPersonnelContact] = useState("")
  const [unitTitle, setUnitTitle] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [tel, setTel] = useState("")
  const [fax, setFax] = useState("")

  useEffect(() => {
    if (item !== undefined && personnelContact !== item) {
      setPersonnelContact(item)
      setUnitTitle(item.unitTitle)
      setName(item.name)
      setEmail(item.email)
      setTel(item.tel)
      setFax(item.fax)
    }
  }, [item])
  

  useEffect(() => {
    if (action !== undefined) {
      var mRespCustomerContract_Contact = new RespCustomerContract_Contact({
        unitTitle,
        name,
        email,
        tel,
        fax
      })
      action(mRespCustomerContract_Contact)
    }
  }, [unitTitle, name, email, tel, fax, action])


  return (
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>人事聯絡窗口</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"單位職稱"} val={unitTitle} action={setUnitTitle} placeholder={"人事部經理"} />
            : <SingleText title={"單位職稱"} val={unitTitle} />
          }
          {isEdit ?
            <SingleInput title={"姓名"} val={name} action={setName} placeholder={"王大同"} />
            : <SingleText title={"姓名"} val={name} />
          }
          {isEdit ?
            <SingleInput title={"電子郵件"} val={email} action={setEmail} placeholder={"XXX@gmail.com"} />
            : <SingleText title={"電子郵件"} val={email} />
          }
          {isEdit ?
            <SingleInput title={"電話"} val={tel} action={setTel} placeholder={"0223921100"} />
            : <SingleText title={"電話"} val={tel} />
          }
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          {isEdit ?
            <SingleInput title={"傳真"} val={fax} action={setFax} placeholder={"0223921111"} />
            : <SingleText title={"傳真"} val={fax} />
          }
          </div>
        </div>
    </>
  )
}